import initialState from '../store/initialState'
import graphsTypes from '../constants/graphsTypes'

export default function graphReducer(state = initialState.graphs, action) {
  switch (action.type) {
    case graphsTypes.reset: {
      return {
        ...state,
        fetching: false,
        fetched: false
      }
    }

    case graphsTypes.clear_dates: {
      return {
        ...state,
        from: null,
        to: null,
        timestamp: null,
        time_start: null,
        fetching: false,
        fetched: false
      }
    }

    case graphsTypes.get.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case graphsTypes.get.success: {
      const { data, from, to, total_users, total_tests, total_paid, timestamp, time_start } = action.payload
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: data,
        from: from,
        timestamp: timestamp,
        to: to,
        time_start: time_start,
        total_users: total_users,
        total_tests: total_tests,
        total_paid: total_paid,
        errors: []
      }
    }

    case graphsTypes.get.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    default: {
      return {
        ...state
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/graphReducer.js